import React from 'react';
import useTranslate from '../../../../Hooks/useTranslate';
import { Paper, Avatar, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import DomainIcon from '@mui/icons-material/Domain';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {
  FullSizeCenteredFlexBox,
  CenteredFlexBox,
} from '../../../../Components/FlexBox';
import capitalize from '../../../../Helpers/StringsFormatting/capitalize';

const SectionHeaderPaper = function SectionHeaderPaper({
  title,
  branchDescription,
  wavePeriod,
}) {
  const translate = useTranslate();
  return (
    <Paper
      sx={{
        padding: '16px',
        height: '80px',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <FullSizeCenteredFlexBox
        gap="24px"
        padding="16px 24px"
        justifyContent="space-between"
      >
        <CenteredFlexBox gap="16px" width="33%">
          <Avatar
            sx={{ bgcolor: '#e3f2fd', color: '#1e88e5', width: 50, height: 50 }}
          >
            <CheckIcon />
          </Avatar>
          <Typography variant="h6" sx={{ fontSize: '24px' }}>
            {translate(title)}
          </Typography>
        </CenteredFlexBox>

        <CenteredFlexBox gap="16px" width="33%" justifyContent="center">
          <Avatar
            sx={{ bgcolor: '#e8f5e9', color: '#43a047', width: 50, height: 50 }}
          >
            <DomainIcon />
          </Avatar>
          <Typography variant="h6" sx={{ fontSize: '24px' }}>
            {capitalize(translate(branchDescription))}
          </Typography>
        </CenteredFlexBox>

        <CenteredFlexBox gap="16px" width="33%" justifyContent="flex-end">
          <Avatar
            sx={{ bgcolor: '#ede7f6', color: '#5e35b1', width: 50, height: 50 }}
          >
            <CalendarMonthIcon />
          </Avatar>
          <Typography variant="h6" sx={{ fontSize: '24px' }}>
            {translate(wavePeriod)}
          </Typography>
        </CenteredFlexBox>
      </FullSizeCenteredFlexBox>
    </Paper>
  );
};
export default SectionHeaderPaper;
